export default __webpack_public_path__ + "static/media/profile_icon.64215f9f.png";